import { getCurrent } from '@/api';
import { NormalBreadcrumb } from '@/components/Breadcrumb';
import { useRequest } from 'ahooks';
import { Card, Col, Radio, Row } from 'antd';
import React, { useState } from 'react';
import { Line } from '@ant-design/plots';
import { getServices } from '@/api/cloud';
import TimeDatePicker from '@/components/TimePicker';

function FirstCard() {
  const { data } = useRequest(getCurrent, { pollingInterval: 3000 });
  return (
    <Card className="m20">
      <Row gutter={[20, 20]}>
        <Col span={6}>
          <Card style={{ height: '100%' }}>
            <div className="" style={{ color: '#aaa' }}>
              CPU使用率
            </div>
            <div className="" style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '8px' }}>
              {data?.result.cpuUsedPercent} %
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: '100%' }}>
            <div className="" style={{ color: '#aaa' }}>
              内存占用
            </div>
            <div className="" style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '8px' }}>
              {data?.result.memoryUsed}
            </div>
            <div className="" style={{ marginTop: '10px', color: '#666' }}>
              <span style={{ borderLeft: '4px solid #172c4d', paddingLeft: '8px', marginRight: '10px' }}>内存总量</span>
              {data?.result.memoryTotal}
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: '100%' }}>
            <div className="" style={{ color: '#aaa' }}>
              系统负载率
            </div>
            <div className="" style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '8px' }}>
              {data?.result.loadUsagePercent} %
            </div>
            <div className="" style={{ marginTop: '10px', color: '#666' }}>
              <span style={{ borderLeft: '4px solid #172c4d', paddingLeft: '8px', marginRight: '10px' }}>流畅程度</span>
              {data?.result.loadInfo}
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: '100%' }}>
            <div className="" style={{ color: '#aaa' }}>
              磁盘占用
            </div>
            <div className="" style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '8px' }}>
              {data?.result.diskUsed}
            </div>
            <div className="" style={{ marginTop: '10px', color: '#666' }}>
              <span style={{ borderLeft: '4px solid #172c4d', paddingLeft: '8px', marginRight: '10px' }}>磁盘总量</span>
              {data?.result.diskTotal}
            </div>
          </Card>
        </Col>
      </Row>
    </Card>
  );
}

function SingleLine({ title, tag, per }: { title: string; tag?: string; per: string }) {
  const [metric_tags, setTag] = useState<string>(tag || 'net_work_tx');

  const [metric_time, setTime] = useState<string>('1h');
  const [list, setList] = useState<{ name: string; time: string; value: number }[]>([]);
  const { run } = useRequest(getServices, {
    defaultParams: [{ metric_time, metric_tags }],
    onSuccess(data) {
      const tList = data.result.series.reduce<{ name: string; time: string; value: number }[]>((pre, cur) => {
        cur.times.forEach((time, index) => {
          pre.push({
            name: cur.container_name,
            time,
            value: cur.values[index],
          });
        });
        return pre;
      }, []);
      setList(tList);
    },
  });
  return (
    <Card
      className=""
      title={
        <>
          {title}
          {!tag && (
            <Radio.Group
              className="ml20"
              optionType="button"
              buttonStyle="solid"
              options={[
                { label: '上行', value: 'net_work_tx' },
                { label: '下行', value: 'net_work_rx' },
              ]}
              value={metric_tags}
              onChange={(e) => {
                setTag(e.target.value);
                run({ metric_time, metric_tags: e.target.value });
              }}
            ></Radio.Group>
          )}
        </>
      }
      extra={
        <TimeDatePicker
          isHideRange
          onChange={(e) => {
            setTime(e.metricsType);
            run({ metric_time: e.metricsType, metric_tags });
          }}
        ></TimeDatePicker>
      }
    >
      <div className="" style={{ width: '100%', height: '300px' }}>
        <Line
          data={list}
          xField="time"
          yField="value"
          seriesField="name"
          yAxis={{ title: { text: `${title}(${per})` }, label: {} }}
          // lineStyle={}
          lineStyle={{ lineWidth: 1.5 }}
          autoFit
          smooth
          tooltip={{ formatter: (data) => ({ name: data.name, value: `${data.value}${per}` }) }}
        ></Line>
      </div>
    </Card>
  );
}

const SystemMonitor = () => {
  return (
    <>
      <NormalBreadcrumb></NormalBreadcrumb>
      <FirstCard></FirstCard>
      <div className="m20">
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <SingleLine title="网络流量" per="KB"></SingleLine>
          </Col>
          <Col span={12}>
            <SingleLine title="CPU使用率趋势" tag="cpu_percent" per="%"></SingleLine>
          </Col>
          <Col span={12}>
            <SingleLine title="内存使用量趋势" tag="memory_usage" per="MB"></SingleLine>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SystemMonitor;
